var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useReducer } from "@wordpress/element";
import { getQueryParam } from "../../utils/url";
import { getUserPageStatusRequest } from "../api/user-page-api";
import { SET_INIT_DATA, SET_USER_PAGE_STATUS, } from "../constants";
import { useErrorHandler } from "../hooks/useErrorHandler";
import { useSession } from "../hooks/useSession";
import { reducer } from "../reducers/user-page-app-reducer";
const initialState = {
    initialLoading: true,
    isActiveUser: false,
    setupCompleted: false,
    isLoggedIn: false,
    pageHash: getQueryParam("code") || "",
    userId: "",
    userName: "",
    cf: false,
    timezone: "",
};
const UserPageAppContext = createContext({
    state: initialState,
    userPageAppDispatch: () => { },
    loadUserPageStatus: () => { },
});
const UserPageAppContextProvider = ({ children, }) => {
    const [state, userPageAppDispatch] = useReducer(reducer, initialState);
    const { isLoggedIn } = useSession();
    const { handleError } = useErrorHandler();
    useEffect(() => {
        const timezone = window.wpqt_user.timezone;
        userPageAppDispatch({
            type: SET_INIT_DATA,
            payload: { timezone },
        });
    }, []);
    useEffect(() => {
        loadUserPageStatus();
    }, []);
    const loadUserPageStatus = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const pageHash = state.pageHash;
            if (pageHash) {
                const userLoggedIn = isLoggedIn();
                const { data } = yield getUserPageStatusRequest(pageHash);
                userPageAppDispatch({
                    type: SET_USER_PAGE_STATUS,
                    payload: Object.assign(Object.assign({}, data), { isLoggedIn: userLoggedIn }),
                });
            }
        }
        catch (error) {
            handleError(error);
        }
    });
    return (_jsx(UserPageAppContext.Provider, { value: { state, userPageAppDispatch, loadUserPageStatus }, children: children }));
};
export { UserPageAppContext, UserPageAppContextProvider, };
